import { Check, Palette } from "lucide-react";
import { useTheme, THEMES } from "@/context/ThemeContext";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          data-testid="theme-toggle"
          aria-label="Choose theme"
          className="relative rounded-md border border-border p-2 hover:border-[#d4af37]/40 transition-colors"
        >
          <Palette className="h-4 w-4 text-[#e5c158]" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64 glass">
        <DropdownMenuLabel className="text-[10px] uppercase tracking-widest text-muted-foreground">
          Appearance
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {THEMES.map((t) => (
          <DropdownMenuItem
            key={t.key}
            data-testid={`theme-option-${t.key}`}
            onClick={() => setTheme(t.key)}
            className="flex items-start gap-3 py-2 cursor-pointer"
          >
            <ThemeSwatch themeKey={t.key} />
            <div className="flex-1 min-w-0">
              <div className="text-sm font-medium">{t.label}</div>
              <div className="text-[11px] text-muted-foreground truncate">{t.hint}</div>
            </div>
            {theme === t.key && <Check className="h-4 w-4 text-[#e5c158] mt-1" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

function ThemeSwatch({ themeKey }) {
  const styles = {
    midnight: "bg-gradient-to-br from-[#0D1B2A] to-[#081421] border-[#24364D]",
    light: "bg-gradient-to-br from-[#fbf9f4] to-[#e9e4d6] border-[#d4c9a8]",
    erp: "bg-gradient-to-r from-[#2563eb] via-[#22c1dc] to-[#7c6df2] border-[#93b4f4]",
    classic: "bg-gradient-to-br from-[#14151A] to-[#0b0c10] border-[#2a2b31]",
  };
  return (
    <div className={`h-8 w-8 rounded-md border shadow-inner flex items-center justify-center ${styles[themeKey] || ""}`}>
      <span className="h-1.5 w-1.5 rounded-full bg-[#d4af37]" />
    </div>
  );
}
